<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="kode..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal Berangkat" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGudangAsal" :options="gudangOptions" :placeholder="'Pilih gudang asal'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudangAsal = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGudangTujuan" :options="gudangOptions" :placeholder="'Pilih gudang tujuan'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudangTujuan = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group mb-0 mr-1">
                    <multiselect v-model="searchStatus" :options="statusOptions" :placeholder="'Pilih status'" :searchable="true"
                        label="value" track-by="name" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>

        <b-modal v-model="selectGudangAsal" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangAsalSelected" @cancel="selectGudangAsal = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectGudangTujuan" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangTujuanSelected" @cancel="selectGudangTujuan = false"></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import GudangSelector from '../gudangs/Selector';

export default {
    components: {
        Multiselect,
        DatePicker,
        GudangSelector,
    },

    data() {
        return {
            selectGudangAsal: false,
            searchGudangAsal: null,
            selectGudangTujuan: false,
            searchGudangTujuan: null,
            gudangOptions: [],
            searchText: '',
            searchDate: '',
            searchStatus: '',
            statusOptions: [
                {
                    'name': 'belum_tiba',
                    'value': 'Belum Tiba',
                },
                {
                    'name': 'sudah_tiba',
                    'value': 'Sudah Tiba',
                },
                {
                    'name': 'pending_pengirim',
                    'value': 'Pending Pengirim',
                },
            ],
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDate : null,
                    searchGudangAsalId: self.searchGudangAsal ? self.searchGudangAsal.id : '',
                    searchGudangTujuanId: self.searchGudangTujuan ? self.searchGudangTujuan.id : '',
                    searchStatus: self.searchStatus ? self.searchStatus.name : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangAsal = null;
            this.searchGudangTujuan = null;
            this.searchStatus = '';
            this.$emit('search-reset');
        },

        gudangAsalSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.searchGudangAsal = Object.assign({}, gudang);
            self.selectGudangAsal = false;
        },

        gudangTujuanSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.searchGudangTujuan = Object.assign({}, gudang);
            self.selectGudangTujuan = false;
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
